import { createAction } from 'typesafe-actions';

export const appInit = createAction(
  'APP_INIT: Application is loading up for the first time.',
);
export const appInitComplete = createAction(
  'APP_INIT_COMPLETE: all initialization actions (including user auth) has completed!',
);
